import React from "react";
import css from "./style.scss";
import { ReactSVG } from "react-svg";
import classNames from "classnames";
import numberFormat from 'utils/number/format';
import currencyFormat from 'utils/currency/numberToPrice';
import EssentialsIcon from "../../../../assets/images/account-page-plan-essentials.svg";
import ProIcon from "../../../../assets/images/account-page-plan-pro.svg";
import EliteIcon from "../../../../assets/images/account-page-plan-elite.svg";
import { planOptions, planTierName } from "../planUtils";
import MonthlyEssentialsIncludes  from "./monthlyEssentialsIncludes";
import SaveAndExportsPopup from "./saveAndExportsPopup";
import MonthlyProIncludes  from "./monthlyProIncludes";
import MonthlyEliteIncludes  from "./monthlyEliteIncludes";
import AnnualEssentialsIncludes  from "./annualEssentialsIncludes";
import AnnualProIncludes  from "./annualProIncludes";
import AnnualEliteIncludes  from "./annualEliteIncludes";
import SVG from 'components/base/SVG';

const PlanCard = ({
  planName,
  planDescription,
  currentPrice,
  discountPrice,
  currentPlan,
  annualPlan,
  extraValue,
  initialAmount,
  planIncludes,
  selectPlan,
  planDisabled,
  selectedPlanOption,
  setSelectedPlanOption,
  planDisMonthlyAmount= null
}) => {
  const getIcon = () => {
    if (planName.includes("Essentials")) return EssentialsIcon;
    else if (planName.includes("Pro")) return ProIcon;
    else return EliteIcon;
  };

  const getPlanDescription = () => {
    if (planName.includes("Essentials")) return "Start Finding Deals";
    else if (planName.includes("Pro")) return "Next Level Performance";
    else return "Power for the Whole Team";
  };

  const getPlanClass = () => {
    if (planName.includes("Pro")) return css.pro;
    else if (planName.includes("Elite")) return css.elite;
    else "";
  };

  const getExtraClass = () => {
    if (planName.includes("Pro")) return css.proBg;
    else if (planName.includes("Elite")) return css.eliteBg;
    else "";
  };

  const getSpace = () => {
    if (annualPlan) return <div className={css.annualExportSpace}>&nbsp;</div>;
    else return <div className={css.monthExportSpace}>&nbsp;</div>;
  };
  return (
    <div
      className={
        planName.includes("Pro")
          ? css.recommendedPlanCard
          : css.recommendedPlanCardNull
      }
    >
      {planName.includes("Pro") ? <span className={css.recommendedTitle}>Recommended</span> : null}
      <div
        className={css.planCard}
        style={annualPlan ? { height: "980px" } : { height: "900px" }}
      >
        <div className={classNames(css.planInfo, { [css.annualPlanInfo] : annualPlan })}>
          <div>
            <div className={css.planHeader}>
              <div>
                <ReactSVG src={getIcon()} className={css.planIcon} />
                <h4 className={getPlanClass()}>{planTierName(planName)}</h4>
              </div>
              <div className={classNames('position-relative')}>
                {annualPlan && (
                  <div className={classNames(css.extraContainer, getExtraClass(), "position-absolute")}>
                    <p className={classNames(css.extraValue, 'm-0')}>{extraValue}%</p>
                    <p className={classNames('m-0')} style={{width: "max-content"}}>
                      Extra Value
                    </p>
                  </div>
                )}
              </div>
            </div>
            <h6>{getPlanDescription()}</h6>
            {planName.includes("Essentials") && (
              <div className={css.saveExportDetail}>
                <p>
                  <SaveAndExportsPopup annualPlan={annualPlan} />
                </p>
                <select name="planOptions" className={css.dropdown} value={selectedPlanOption} onChange={(e) => {
                  setSelectedPlanOption(e.target.value)}
                }>
                  {planOptions && planOptions.map(plan => <option key={plan} value={plan}>{numberFormat(plan)}/mo</option>)}
                </select>
                <SVG icon="iconCaretDown" className={css.selectCaret} />
              </div>
            )}
          </div>
          <div>
          <div className={css.planPrice}>
            <p className={css.priceStarts}>
              {planName.includes("Essentials") && planOptions && planOptions.length > 0 && Number(selectedPlanOption) === planOptions[0] ? "Starting at " : ""}
              {annualPlan ? <span>${initialAmount}/mo</span> : ""}
            </p>
            <p className={css.price}>
              <span>${planDisMonthlyAmount ? planDisMonthlyAmount : currentPrice}</span>/mo
            </p>
            {annualPlan ? <p className={css.annual}>billed annually</p> : ""}
            </div>
            <button onClick={selectPlan} className={classNames(css.clsBtnOrng, css.btn_fullwidth)} disabled={planDisabled}>{planDisabled ? "Current Plan" : "Choose Plan and Continue"}</button>
          </div>
        </div>
        <div>
          <h5>{planTierName(planName)} Includes:</h5>
          <ul>
            {planName.includes("Essentials") && <MonthlyEssentialsIncludes selectedPlanOption={selectedPlanOption} />}
            {planName.includes("Pro") && <MonthlyProIncludes selectedPlanOption={selectedPlanOption} />}
            {planName.includes("Elite") && <MonthlyEliteIncludes selectedPlanOption={selectedPlanOption} />}
          </ul>
          {annualPlan && <ul className={css.annual}>
            {planName.includes("Essentials") && <AnnualEssentialsIncludes />}
            {planName.includes("Pro") && <AnnualProIncludes />}
            {planName.includes("Elite") && <AnnualEliteIncludes />}
          </ul>}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
